import { GET_MESSAGE } from "./const";

export default {
    [GET_MESSAGE](state) {
        return state.message;
    }
}